import moment from 'moment';
import { GachaTicket } from 'types/gacha-tickets';
import { TEXT_STRING } from '../../../constants';
const str = TEXT_STRING.GACHA_TICKETS;

export const ticketName = (ticket: GachaTicket) => ticket.ticketType === 'SET'
  ? str.SET_NAME : ticket.gameName?.trim() || str.UNKNOWN_GAME;
export const ticketKind = (ticket: GachaTicket) => ticket.ticketType === 'SET' ? str.SET_TICKET : str.GAME_TICKET;
export const ticketDate = (iso: string) => moment.utc(iso).utcOffset(9).format('YYYY.MM.DD');
export const isUrgent = (ticket: GachaTicket) => ticket.remainingDays !== null && ticket.remainingDays <= 3;
export const ticketExpiry = (ticket: GachaTicket) => ticket.remainingDays === 0
  ? str.EXPIRES_TODAY.replace('$time', moment.utc(ticket.expiresAt).utcOffset(9).format('HH:mm'))
  : str.DAYS_LEFT.replace('$count', String(ticket.remainingDays));

export function groupTickets(tickets: GachaTicket[]) {
  const groups = new Map<string, GachaTicket[]>();
  const sorted = [...tickets].sort((a, b) =>
    Date.parse(a.expiresAt) - Date.parse(b.expiresAt) || a.ticketId - b.ticketId);
  sorted.forEach((ticket) => {
    const key = ticket.ticketType === 'SET' ? 'set' : `game-${ticket.gameId}`;
    const group = groups.get(key) ?? [];
    group.push(ticket);
    groups.set(key, group);
  });
  return Array.from(groups, ([key, items]) => ({ key, items, first: items[0] }));
}
